import React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  onOk: () => void;
  onCancel: () => void;
};

const ActionCalendarContainer = React.forwardRef<HTMLDivElement, Props>(
  function ActionCalendarContainer(
    { className, children, onOk, onCancel },
    ref
  ) {
    return (
      <div ref={ref} className={className}>
        {/* カレンダー本体 */}
        <div className="rdp-body">{children}</div>

        {/* フッター（キャンセル / OK） */}
        <div className="rdp-footer d-flex justify-content-center gap-2 px-3 py-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onCancel}
          >
            キャンセル
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={onOk}
          >
            OK
          </button>
        </div>
      </div>
    );
  }
);

export default ActionCalendarContainer;
